import repository from "../Repository";

/**
 * イベント関連のAPIにリクエストします
 */
const event = "/event";
const eventList = "/event/list";
const eventRanking = "/event/ranking";
const eventSummary = "/event/summary";
export default {
  /**
   * イベント詳細を取得します
   * @param params
   */
  getEvent(params) {
    return repository.get(event, { params });
  },

  /**
   * イベントリストを取得します
   * @param params
   */
  getEventList(params) {
    return repository.get(eventList, { params });
  },

  /**
   * イベントサマリを取得します
   * @param params
   */
  getEventRanking(params) {
    return repository.get(eventRanking, { params });
  },

  getEventSummary(params) {
    return repository.get(eventSummary, { params });
  },
};



// WEBPACK FOOTER //
// ./src/api/contents/EventRepository.js